import { Store } from "pullstate";


export const SubStore = new Store({
   selectPrice:null
  });